import React, { useState, useEffect } from 'react';
import { setTimeProgress } from '../redux/actions/player-actions';
import { connect } from 'react-redux';

const ProgressBar = ({
  tag,
  saveFlag,
  takeHighlight,
  onComplete,
  timeProgress,
  setTimeProgress_disp
}) => {
  useEffect(() => {
    const interval = setInterval(() => {
      setTimeProgress_disp(timeProgress >= 100 ? 100 : timeProgress + 1);
    }, 50);

    if (timeProgress >= 100) {
      clearInterval(interval); // Clear the interval when progress reaches 100%
      if (tag !== undefined) {
        saveFlag(tag, undefined);
      } else {
        takeHighlight();
      }
      onComplete();
    }

    return () => clearInterval(interval);
  }, [timeProgress]);

  return (
    <div
      style={{
        width: `${timeProgress}%`,
        height: '40px',
        backgroundColor: 'var(--color-ai-green)',
        color: 'white',
        textAlign: 'center',
        lineHeight: '30px',
        marginBottom: '10px',
        borderRadius: '8px',
        marginTop: '-40px',
        opacity: '0.7',
        transition: 'width 0.0s ease-in-out'
      }}
    ></div>
  );
};

const mapStateToProps = (store) => {
  return {
    timeProgress: store.player.timeProgress
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTimeProgress_disp: (value) => {
      dispatch(setTimeProgress(value));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProgressBar);
